import React from 'react';
import './index.css';
import BooksList from './container/BooksList';
import BooksForm from './container/BooksForm';
import Header from './components/header';

function App() {
  return (
    <div className="App">
      <Header />
      <BooksList />
      <BooksForm />
    </div>
  );
}

export default App;
